import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { Actions as ActionsBase, ActionsItem } from '@common/components/actions';
import { SpreadsheetType } from '@modules/spreadsheets/dto/spreadsheet/type';
import {getUserPermissions} from "@common/actions/permissions";
import { UserPermissions } from '@common/dto/user/permissions';

import './actions.styles.scss';

export type ActionsProps = {
  spreadsheetType: SpreadsheetType;
  disabledState: {
    undo: boolean;
    redo: boolean;
    export: boolean;
  };
  className?: string;
  onLoadFormat: () => void;
  onSaveFmt: () => void;
  onEdit: () => void;
  onExport: () => void;
  onImport: () => void;
  onBatchLetters: () => void;
  onBatchInvites: () => void;
  onCount: () => void;
  onUndo: () => void;
  onRedo: () => void;
  onAddRow?: () => void;
  onDeleteRow?: () => void;
  canAddRow?: boolean;
  canDeleteRow?: boolean;
  isAddingRow: boolean;
  isDeletingRow: boolean;
  isProcessingUndoRedo: boolean;
  canImportSpreadsheet: boolean;
};

export const Actions: React.FC<ActionsProps> = (props) => {
  const { 
    onSaveFmt, 
    onLoadFormat, 
    disabledState, 
    onEdit, 
    onExport, 
    onImport, 
    onBatchLetters, 
    onBatchInvites, 
    onCount,
    onUndo,
    onRedo,
    onAddRow,
    onDeleteRow,
    canAddRow,
    canDeleteRow,
    spreadsheetType,
    isAddingRow,
    isDeletingRow,
    isProcessingUndoRedo,
    canImportSpreadsheet
  } = props;

  const [userPermissions, setUserPermissions] = React.useState<UserPermissions | null>(null);
  const fetchUserPermissions=async()=>{
    const res=await getUserPermissions();
    setUserPermissions(res);
  }

  React.useEffect(() => {
    fetchUserPermissions();
  }, []);


  const actions: Array<ActionsItem> = [
    {
      iconSrc: 'png/ss_edit.png',
      label: 'Edit',
      onClick: onEdit,
    },
    {
      iconSrc: 'gif/load_fmt.gif',
      label: 'Load Fmt',
      onClick: onLoadFormat,
    },
    {
      iconSrc: 'gif/save_fmt.gif',
      label: 'Save Fmt',
      onClick: onSaveFmt,
    },
    {
      iconSrc: 'gif/ss_export.gif',
      label: 'Export',
      disabled: disabledState.export,
      onClick: onExport,
    },
    {
      condition: canImportSpreadsheet,
      iconSrc: 'gif/ss_import.gif',
      label: 'Import',
      onClick: onImport,
    },
    {
      condition: spreadsheetType === SpreadsheetType.individual,
      iconSrc: 'png/letter.png',
      label: 'Batch Letters',
      onClick: onBatchLetters,
    },
    {
      condition: spreadsheetType === SpreadsheetType.individual,
      iconSrc: 'png/invite_status2.png',
      label: 'Batch Invites',
      onClick: onBatchInvites,
    },
    {
      iconSrc: 'gif/count.gif',
      label: 'Count',
      onClick: onCount,
    },
    {
      iconSrc: 'png/undo.png',
      label: 'Undo',
      disabled: disabledState.undo || isDeletingRow || isAddingRow,
      onClick: onUndo,
    },
    {
      iconSrc: 'png/redo.png',
      label: 'Redo',
      disabled: disabledState.redo || isDeletingRow || isAddingRow,
      onClick: onRedo,
    },
    {
      condition: canAddRow,
      iconSrc: 'gif/add_row.gif',
      label: 'Add Row',
      disabled: isDeletingRow || isAddingRow || isProcessingUndoRedo,
      onClick: onAddRow ? () => onAddRow() : () => {},
    },
    {
      condition: canDeleteRow,
      iconSrc: 'gif/delete_row.gif',
      label: 'Delete Row',
      disabled: isAddingRow || isDeletingRow || isProcessingUndoRedo,
      onClick: onDeleteRow ? () => onDeleteRow() : () => {},
    }
  ]
  .filter((x) => x.condition ?? true)
  .map(({ label, ...restData }, index) => ({ 
    ...restData, 
    id: spreadsheetType === SpreadsheetType.individual 
      ? `ISSC-sswnd-item${index}-btn`
      : `PSSC-sswnd-item${index}-btn`,
    label: I18n.t(label),
  }));

  return <ActionsBase items={actions} />;
};